<template>
	<v-container class="noMargin">
		<v-layout row wrap>					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>DISCOUNT REQUEST REPORTS</h2>					
				</div>	
				<v-btn @click.prevent="fncFilterDiscount()" class="elevation-5" color="info"><i class="material-icons">filter_list</i>FILTER / CUSTOMIZE REPORT</v-btn>
				<v-btn @click.prevent="fncExportDiscount()" class="elevation-5" color="info"><i class="material-icons">close</i>EXPORT TO CSV</v-btn>
				<v-btn @click.prevent="fncReloadDiscount" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
	</v-container>	
</template>

<script>

    import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {			
			}		
		},
		methods: {
            fncFilterDiscount() {
				var modalDetails = { title: 'Discount Request Filter', component: 'modal-filter-discount', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
			},
            fncExportDiscount() {			    
                var discountHistory = 'Request Timestamp, Request Status, Draft Reference, Quote Reference, Customer, Requestor, Receiver, Product Code to discount, Quantity, Unit Price, Discount %, Nett Price, Total' + "\n";
                for( var i =0; i<this.discountList.length; i++ ) {
                    var discount = this.discountList[i];
                    for( var n = 0; n<discount.items.length; n++  ) {
                        discountHistory += discount.created+ ",";
                        discountHistory += discount.request_status_display+ ",";
                        discountHistory += discount.draft_reference+ ",";
                        discountHistory += discount.quote_no+ ",";
                        discountHistory += discount.metadata.customer_name+ ",";
                        discountHistory += discount.metadata.requestor_user_name+ ",";
                        discountHistory += discount.receiver.fullname+ ",";
                        discountHistory += discount.items[n].code+ ",";
                        discountHistory += discount.items[n].quantity+ ",";
                        discountHistory += 'R'+discount.items[n].price.toFixed(2)+ ",";
                        discountHistory += discount.items[n].discount_percent+ "%,";
                        var nettPrice = parseFloat( discount.items[n].price ) - parseFloat( discount.items[n].discount );
                        discountHistory += 'R'+nettPrice.toFixed(2)+ ",";
                        var totalPrice = parseFloat( discount.items[n].quantity ) * parseFloat( nettPrice );
                        discountHistory += 'R'+totalPrice.toFixed(2)+ ",";
                        discountHistory += "\n";
					}
                }
                var discountDownload = document.createElement('a');
                discountDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(discountHistory));
                discountDownload.setAttribute('download', 'discountreport.csv');
                discountDownload.click();
            },
            fncReloadDiscount() {
              this.$store.commit('fncEmptyDiscountReport');
              this.$store.dispatch({
                type: 'fncPopulateDiscountList',
                objFilters: this.objDiscountReportFilters,
                reload: true
              });
            }
		},
        computed: {
            ...mapGetters([
              'discountList',
              'objDiscountReportFilters'
            ])
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>